import { MbeEdit } from '@/components/icons';
import type { IMBEStore } from '@/types';
import { Flex, Heading, IconButton, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IStoreInfoBoxProps {
  onOpen?: () => void;
  store: IMBEStore;
}

export const StoreInfoBox: React.FC<IStoreInfoBoxProps> = ({ onOpen, store }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Flex
      border="1px"
      borderColor="brand.gray"
      flexDirection="column"
      gap={2}
      p={4}
      position="relative"
    >
      {onOpen && (
        <IconButton
          aria-label="Open Store Selector Modal"
          icon={<MbeEdit h={8} w={8} />}
          position="absolute"
          right={3}
          top={3}
          onClick={onOpen}
        />
      )}
      <Text textTransform="uppercase">{t('STORE.INFOBOX_TITLE')}</Text>
      <Heading size="md">{store.name}</Heading>
      <Text as="span">
        {store.streetAddress},<br />
        {store.zipCode} {store.city}
      </Text>
      <Text as="span">
        {t('STORE.PHONE_NUMBER')} {store.phoneNumber} <br />
        {t('STORE.MAIL')} {store.email}
      </Text>
    </Flex>
  );
};
